module.exports = __webpack_public_path__ + "static/img/1.7fabc20.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/2/zh/1.png
// module id = Nt3G
// module chunks = 0